// NOTE: Don't be fooled by the filename. This is/was code that is functional on multiple pages (for example, this also has functionality for Worklist Orders status collapsing by clicking the h3.panelHeader)

$(function () {
    $('html').off('click', 'h3.panelHeader');
    $('html').on('click', 'h3.panelHeader', function (e) {
        if ($(this).hasClass('panelHeaderWorklistOrders')) // Disable this functionality for Worklist Orders
            return;

        if ($(this).hasClass('panelHeaderPassive')) {
            $(this).addClass('panelHeaderActive');
            $(this).removeClass('panelHeaderPassive');
            $(this).next().slideDown(200);
        }
        else {
            $(this).addClass('panelHeaderPassive');
            $(this).removeClass('panelHeaderActive');
            $(this).next().slideUp(200);
        }
    });

    $('html').off('click', 'h3.visibleRooms, h3.visibleStatus, h3.visibleModalities, h3.visibleLabels, h3.visibleSpecialisms, h3.visibleColumns, h3.productCategoryName, h3.appointmentHistoryItem, h3.visibleUrgencies, h3.visiblePatientStatuses, h3.visiblePatientOrigins, h3.visibleInvoiceStatuses, h3.authorSupervisor');
    $('html').on('click', 'h3.visibleRooms, h3.visibleStatus, h3.visibleModalities, h3.visibleLabels, h3.visibleSpecialisms, h3.visibleColumns, h3.productCategoryName, h3.appointmentHistoryItem, h3.visibleUrgencies, h3.visiblePatientStatuses, h3.visiblePatientOrigins, h3.visibleInvoiceStatuses, h3.authorSupervisor', function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        if ($(this).hasClass('passive')) {
            $(this).addClass('active');
            $(this).removeClass('passive');
            $(this).next().slideDown(200);
        }
        else {
            $(this).addClass('passive');
            $(this).removeClass('active');
            $(this).next().slideUp(200);
        }
    });

    $('html').off('click', 'div#roomCheckBoxes, div#statusCheckBoxes, div#columnCheckBoxes, div#modalityCheckBoxes, div#labelsCheckBoxes, div#specialismsCheckBoxes, div#urgencyCheckBoxes, div#patientStatusCheckBoxes, div#patientOriginsCheckBoxes, div#invoiceStatusCheckBoxes, div#authorSupervisorCheckBoxes');
    $('html').on('click', 'div#roomCheckBoxes, div#statusCheckBoxes, div#columnCheckBoxes, div#modalityCheckBoxes, div#labelsCheckBoxes, div#specialismsCheckBoxes, div#urgencyCheckBoxes, div#patientStatusCheckBoxes, div#patientOriginsCheckBoxes, div#invoiceStatusCheckBoxes, div#authorSupervisorCheckBoxes', function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    });

    $('html').on('click');
    $('html').on('click', function (e) {
        if ($('h3.visibleRooms').hasClass('active')) {
            $('h3.visibleRooms').addClass('passive');
            $('h3.visibleRooms').removeClass('active');
            $('h3.visibleRooms').next().slideUp(200);
        };
        if ($('h3.visibleUrgencies').hasClass('active')) {
            $('h3.visibleUrgencies').addClass('passive');
            $('h3.visibleUrgencies').removeClass('active');
            $('h3.visibleUrgencies').next().slideUp(200);
        };
        if ($('h3.visiblePatientStatuses').hasClass('active')) {
            $('h3.visiblePatientStatuses').addClass('passive');
            $('h3.visiblePatientStatuses').removeClass('active');
            $('h3.visiblePatientStatuses').next().slideUp(200);
        };
        if ($('h3.visiblePatientOrigins').hasClass('active')) {
            $('h3.visiblePatientOrigins').addClass('passive');
            $('h3.visiblePatientOrigins').removeClass('active');
            $('h3.visiblePatientOrigins').next().slideUp(200);
        };
        if ($('h3.visibleInvoiceStatuses').hasClass('active')) {
            $('h3.visibleInvoiceStatuses').addClass('passive');
            $('h3.visibleInvoiceStatuses').removeClass('active');
            $('h3.visibleInvoiceStatuses').next().slideUp(200);
        };
        if ($('h3.visibleStatus').hasClass('active')) {
            $('h3.visibleStatus').addClass('passive');
            $('h3.visibleStatus').removeClass('active');
            $('h3.visibleStatus').next().slideUp(200);
        };
        if ($('h3.visibleModalities').hasClass('active')) {
            $('h3.visibleModalities').addClass('passive');
            $('h3.visibleModalities').removeClass('active');
            $('h3.visibleModalities').next().slideUp(200);
        };
        if ($('h3.visibleLabels').hasClass('active')) {
            $('h3.visibleLabels').addClass('passive');
            $('h3.visibleLabels').removeClass('active');
            $('h3.visibleLabels').next().slideUp(200);
        };
        if ($('h3.visibleSpecialisms').hasClass('active')) {
            $('h3.visibleSpecialisms').addClass('passive');
            $('h3.visibleSpecialisms').removeClass('active');
            $('h3.visibleSpecialisms').next().slideUp(200);
        };
        if ($('h3.visibleColumns').hasClass('active')) {
            $('h3.visibleColumns').addClass('passive');
            $('h3.visibleColumns').removeClass('active');
            $('h3.visibleColumns').next().slideUp(200);
        };
        if ($('h3.productCategoryName').hasClass('active')) {
            $('h3.productCategoryName').addClass('passive');
            $('h3.productCategoryName').removeClass('active');
            $('h3.productCategoryName').next().slideUp(200);
        };
        if ($('h3.authorSupervisor').hasClass('active')) {
            $('h3.authorSupervisor').addClass('passive');
            $('h3.authorSupervisor').removeClass('active');
            $('h3.authorSupervisor').next().slideUp(200);
        };
    });
});
